module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_gamepub.9d421d0fc1172dcf8a9741301c4767ab.png";